// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"8f5e70f1","241":"6b9cb376","362":"6d492dca","423":"46dcb95a","466":"bbbbf526","838":"dc5a73ea","909":"48f7cc5f","959":"b7bf8aca"}[chunkId] + ".chunk.css";
};